const Port = (() => {
  const localport = ':3100';
  const fairport = ':8485';
  // const globelport = ':1337';
  // const globelport = ':1947';
  const globelport = ':1338';

  // const globelport = ':1580';
  const smartsearchip = ':4044';
  return { localport, fairport, globelport, smartsearchip }; // Expose these variables
})();
export default Port;
